<!-- Router Navigation that outputs into router-view tag. Routes are referred by name in ../routes.js -->
<template>

</template>

<script>
import { mapGetters, mapState } from "vuex"
import { GlobalEventBus } from "@tenant/shared/GlobalEventBus"

export default {
    name: "ApplicationRouter",
    data() {
        return {
            showDocumentGenerator: false, //cali
            resumeLast: false,
            userId: this.initialUserId,
            brokers: [],
            employmentStatuses: [],
            employmentIndustries: [],
            residentialStatuses: [],
            sellerTypes: [],
            applicationJoins: [],
            leadTypes: [],
            assetTypes: [],
            loanTypes: [],
            documentTypes: [],
            referrers: [],
            sources: [],
            adminReferrerUsers: [],
            closeReasons: [],
            permissions: [],
            preferredRepaymentFrequency: [
                { label: "Weekly", value: "Weekly" },
                { label: "Fortnightly", value: "Fortnightly" },
                { label: "Monthly", value: "Monthly" },
                { label: "Quarterly", value: "Quarterly" },
                { label: "Annual", value: "Annual" },
            ],
            applicationTypes: [
                { label: "Consumer", value: 1 },
                { label: "Commercial", value: 2 },
            ],
            paymentTypes: [
                { label: "Arrears", value: 0 },
                { label: "Advance", value: 1 },
            ],

            applicants: [],
            showInfoBar: false,
            isNavStuck: false,
            swappingApplicants: false,
        }
    },
    props: [
        "initialUserId",
        "userRoles",
        "isBroker",
        "token",
        "tenant",
        "adminToken",
        "adminSettings",
        "appInitData",
        "isReferrer",
        "timezone",
        "enableSmsHub",
        "enableDigitalAncillaries",
        "enableMonthlyFrequencyForExpenses",
        "canEditCompletedApp",
        "canQuote",
        "userSettings",
        "dropDownOptions",
    ],
    computed: {
        ...mapGetters({
            application: "initAppData",
            usersViewingApp: "statusIndicators/usersViewingApp",
            newApplication: "statusIndicators/new",
            appTaken: "statusIndicators/appTaken",
            documentsReceived: "statusIndicators/documentsReceived",
            submittedToLender: "statusIndicators/submittedToLender",
            conditionallyApproved: "statusIndicators/conditionallyApproved",
            invoiceRequested: "statusIndicators/invoiceRequested",
            invoiceReturned: "statusIndicators/invoiceReturned",
            optionsSent: "statusIndicators/optionsSent",
            optionsReceived: "statusIndicators/optionsReceived",
            loanSubmitted: "statusIndicators/loanSubmitted",
            loanApproved: "statusIndicators/loanApproved",
            contractSent: "statusIndicators/contractSent",
            contractReceived: "statusIndicators/contractReceived",
            settled: "statusIndicators/settled",
            completed: "statusIndicators/completed",
        }),
        editorOnline: function () {
            return this.$store.getters["statusIndicators/usersViewingApp"].find(
                (x) => x.id == _.get(this.$store.getters, "editLock")
            )
        },
        showApplicationTabPermission() {
            let show = this.$store.state.user.user_permissions.find((item) => {
                if (item.name === "show application tab") {
                    return item
                }
            })
            return !!show
        },
        showLenderSubmissionTabPermission() {
            let show = this.$store.state.user.user_permissions.find((item) => {
                if (item.name === "show lender submission tab") {
                    return item
                }
            })
            return !!show
        },
        allowApplicantSwap() {
            let editLockUser = _.get(this.$store.getters, "editLock")
            let brokerId = !_.isNull(editLockUser) ? editLockUser : _.get(this.$store.getters, "broker_id")
            return (
                this.application.application_status_id < 14 &&
                this.application.status != 3 &&
                Ambition.Globals.tenant.user.id === brokerId
            )
        },
        qualifyingQuestionnaireFinalised() {
            if (!Ambition.qualifyingQuestionnaireEnabled()) return true
            return _.has(this.application.qualifying_questionnaire, "finalised", false) &&
                this.application.qualifying_questionnaire.finalised
                ? true
                : false
        },
    },
    created() {

        this.showDocumentGenerator = process.env.MIX_DOCUMENT_GENERATOR == "true"
        this.$store.dispatch("saveCanEditCompleted", this.canEditCompletedApp)
        this.$store.dispatch("saveEnableDigitalAncillaries", this.enableDigitalAncillaries)
        this.$store.dispatch("saveEnableMonthlyFrequencyForExpenses", this.enableMonthlyFrequencyForExpenses)
        this.$store.dispatch("saveTimezone", this.timezone)
        this.$store.dispatch("saveToken", this.token)
        this.$store.dispatch("saveAdminToken", this.adminToken)
        this.$store.dispatch("saveAdminSettings", this.adminSettings)
        this.$store.dispatch("saveAppData", this.appInitData)
        this.$store.dispatch("saveAppId", this.appInitData.id)

        if (this.appInitData.broker_id) this.$store.dispatch("saveBrokerId", this.appInitData.broker_id)
        if (this.appInitData.asset_json_information)
            this.$store.dispatch("saveAssetInfo", JSON.parse(this.appInitData.asset_json_information))
        if (this.appInitData.loan_type_id) this.$store.dispatch("summary/saveLoanType", this.appInitData.loan_type_id)
        this.$store.dispatch("statusIndicators/initialiseStatus", {
            status_id: this.appInitData.application_status_id + 1,
        })
        let applicants = []
        this.appInitData.aai.map(function (aai) {
            aai.applicant.firstName = aai.applicant.first_name
            aai.applicant.lastName = aai.applicant.last_name
            aai.applicant.applicantId = aai.applicant.id
            applicants.push(aai.applicant)
        })
        this.$store.dispatch("application/saveApplicants", applicants)
        this.storeFinanceDetails(this.appInitData)

        this.$store.dispatch("saveAdminReferrerUsers", this.adminReferrerUsers)

        this.$store.dispatch("user_roles/saveIsBroker", this.isBroker == "true")
        this.$store.dispatch("user_roles/saveIsReferrer", this.isReferrer) // save the referrer role
        this.$store.dispatch("user_roles/saveRoles", JSON.parse(this.userRoles))
        this.$store.dispatch("user/saveUser", this.$store.getters.token)
        this.$store.dispatch("invoice/saveInvoiceInformation", this.appInitData.invoice_information)
        this.$store.dispatch("emailForwards/retrieveEmailForwards", {
            token: this.$store.getters.token,
            application_id: this.application.id,
        })

        if (this.appInitData.is_submitted && this.isReferrer) {
            this.$store.dispatch("referrer/saveAppSubmitted", true)
        }
    },
    mounted() {
        this.brokers = _.get(this.dropDownOptions, "brokers", [])
        this.employmentStatuses = _.get(this.dropDownOptions, "employmentStatuses", [])
        this.employmentIndustries = _.get(this.dropDownOptions, "employmentIndustries", [])
        this.residentialStatuses = _.get(this.dropDownOptions, "residentialStatuses", [])
        this.sellerTypes = _.get(this.dropDownOptions, "sellerTypes", [])
        this.applicationJoins = _.get(this.dropDownOptions, "applicationJoins", [])
        this.loanTypes = _.get(this.dropDownOptions, "loanTypes", [])
        this.assetTypes = _.get(this.dropDownOptions, "assetTypes", [])
        this.documentTypes = _.get(this.dropDownOptions, "documents", [])
        this.sources = _.get(this.dropDownOptions, "sources", [])
        this.sourceDetails = _.get(this.dropDownOptions, "sourceDetails", [])
        this.referrers = _.get(this.dropDownOptions, "referrers", [])
        this.permissions = _.get(this.dropDownOptions, "permissions", [])
        this.closeReasons = _.get(this.dropDownOptions, "closeReasons", [])
        this.leadTypes = _.get(this.dropDownOptions, "leadTypes", [])

        this.storeBrokers(this.brokers, "options/saveBrokers")
        this.storeOptions(this.employmentStatuses, "options/saveEmploymentStatuses")
        this.storeOptions(this.employmentIndustries, "options/saveEmploymentIndustries")
        this.storeOptions(_.get(this.dropDownOptions, "occupations", []), "options/saveOccupations")
        this.storeOptions(this.residentialStatuses, "options/saveResidentialStatuses")
        this.storeOptions(this.sellerTypes, "options/saveSellerTypes")
        this.storeOptions(this.loanTypes, "options/saveLoanTypes")
        this.storeAssetTypes(this.assetTypes, "options/saveAssetTypes")
        this.storeReferrers(this.referrers, "options/saveReferrers")
        this.storeOptions(this.documentTypes, "options/saveDocumentTypes")
        this.storeOptions(this.closeReasons, "options/saveCloseReasons")
        this.$store.dispatch("options/savePreferredRepaymentFrequency", this.preferredRepaymentFrequency)
        this.$store.dispatch("options/saveApplicationTypes", this.applicationTypes)
        this.$store.dispatch("options/savePaymentTypes", this.paymentTypes)
        this.$store.dispatch("options/saveSources", this.sources)
        this.$store.dispatch("options/saveSourceDetails", this.sourceDetails)
        this.$store.dispatch("options/saveApplicationJoins", this.applicationJoins)
        this.$store.dispatch("options/saveLeadTypes", this.leadTypes)
        this.storeOptions(_.get(this.dropDownOptions, "repaymentTerms", []), "options/savePreferredRepaymentTerm")
        this.$store.dispatch("savePermissions", this.permissions)

        this.$store.dispatch("options/saveLenders", _.get(this.dropDownOptions, "lenders", []))

        this.$store.dispatch("options/saveApplicationCategories", _.get(this.dropDownOptions, "applicationCategories", []))

        const headers = { Authorization: "Bearer " + this.$store.getters.token }
        const appId = this.application.id

        this.$store.dispatch("user/setSettings", this.userSettings)

        // Get dealer ID first
        axios
            .get(`/api/applications/${appId}/applicants`, {
                headers,
            })
            .then((res) => {
                this.applicants = res.data.applicants
            })
            .catch((e) => {
                throw Error(e)
            })

        if (this.resume) {
            // Get stage that user stopped at and replace with name.
            this.$router.replace({ name: "Invoice" })
        }

        if (_.get(this.application, 'application_status_id', false) === 15) {
            this.$notify({
                title: 'Application Completed',
                message: 'This application is completed and no changes will be saved.  To make changes, change the application back to "In For Settlement" or an earlier stage before editing the application.  You will need to have control of the application to make changes.',
                position: 'bottom-right',
                duration: 0,
                type: 'warning',
                offset: 50,
                showClose: true
            });
        }
    },
    activated() {

    },
    beforeDestroy() {

    },
    methods: {

        // Make tab menu sticky on scroll (TODO: move this to API, refactor)
        stickyScroll() {
            // const $stickyNav = $(this.$refs.stickyNav)
            // const $stickyNavInner = $(this.$refs.stickyNavInner)
            // const $header = $("header")
            // const $toggle = $(".navbar-toggler")
            // const $links = $stickyNav.find("#tabs-panel > a:visible")

            // // let $links = null
            // let defaultCss = {}
            // let intervals = {}

            // defaultCss.linkWidth = $links.css("width")

            // const adjustPosition = () => {
            //     const $currentNav = $("#app-info-panel-nav").length > 0 ? $("#app-info-panel-nav") : $("#js-amb-top-nav")
            //     const $tabsPanel = $("#tabs-panel")

            //     if (this.$route.name === "Application") {
            //         // const stickyNavHeight = $stickyNavInner.outerHeight()
            //         // $stickyNavInner.css({ top: 0 })
            //         setTimeout(() => {
            //             //
            //             //   $currentNav.css({ top: $tabsPanel.outerHeight() })
            //         })
            //         return
            //     }

            //     const navHeight = $currentNav.outerHeight()
            //     const topMargin = -3
            //     const openTop = navHeight + 3 + topMargin
            //     const shutTop = 25 + topMargin
            //     // $stickyNavInner.css({ top: $currentNav.hasClass('closed') ? shutTop : openTop })
            // }

            // const stickNav = () => {
            //     const $header = $("header")

            //     $header.addClass("closed sticky-active")
            //     // let stickyHeight = $('.application-tab-nav').outerHeight()
            //     // $("#marker-step-six-options").css({
            //     //     marginTop: stickyHeight
            //     // });

            //     // defaultCss.linkWidth = $links.css('width')

            //     // Adjust width of links to relative (%)
            //     const linkRelativeWidth = 100 / $links.length
            //     $links.css({ width: `${linkRelativeWidth}%` })

            //     this.isNavStuck = true

            //     // Hide info panel if on Application tab
            //     this.showInfoBar = this.$route.name == "Application"
            // }

            // const unstickNav = () => {
            //     const $header = $("header")

            //     $header.removeClass("closed sticky-active")
            //     $header.removeClass("amb-top-nav-hide")
            //     $header.addClass("amb-top-nav-show")

            //     // $("#marker-step-six-options").css({
            //     //     marginTop: 0
            //     // });

            //     // Adjust width of links to absolute (px)
            //     // $links.css('width', defaultCss.linkWidth)
            //     $links.css("width", "")
            //     // $('#marker-accordion-sms-hub').width() / 12 - (6)

            //     this.isNavStuck = false
            // }

            // const openMenu = () => {
            //     $header.removeClass("closed")
            // }

            // const shutMenu = () => {
            //     $header.addClass("closed")
            //     $("#ambNavbarCollapse").removeClass("show")
            //     $toggle.addClass("collapsed")
            // }

            // // On scroll down
            // new IntersectionObserver(
            //     (entries, observer) => {
            //         const ratio = entries[0].intersectionRatio
            //         //
            //         if (ratio < 1) {
            //             stickNav()
            //             adjustPosition()
            //         }
            //     },
            //     {
            //         root: document.querySelector("#app"),
            //         rootMargin: "100px",
            //         threshold: 1.0,
            //     }
            // ).observe(document.querySelector("#tabs-panel"))

            // // On scroll back to top
            // new IntersectionObserver(
            //     (entries, observer) => {
            //         const ratio = entries[0].intersectionRatio
            //         //
            //         if (ratio === 1) unstickNav()
            //     },
            //     {
            //         root: document.querySelector("#app"),
            //         rootMargin: "100px",
            //         threshold: 1.0,
            //     }
            // ).observe(document.querySelector(".app-title"))

            // //  Global jQuery events
            // const self = this
            // $(() => {
            //     // When draw arrow is clicke
            //     $(".header-draw").bind("click.drawer", function () {
            //         const isClosed = $header.hasClass("closed")
            //         if (isClosed) openMenu()
            //         else shutMenu()
            //         adjustPosition()
            //     })
            // })
        },

        storeOptions: function (data, action) {
            let optionList = []
            data.map((element) => {
                optionList.push({
                    label: element.name,
                    value: element.id,
                    name: _.camelCase(element.name),
                })
            })
            this.$store.dispatch(action, optionList)
        },
        storeAssetTypes(data, action) {
            let optionList = []
            data.map((element) => {
                optionList.push({
                    label: _.get(element, "label", _.get(element, "name")),
                    name: _.get(element, "label", _.get(element, "name")),
                    value: _.get(element, "id", _.get(element, "value")),
                    categories: _.get(element, "asset_categories"),
                })
            })
            this.$store.dispatch(action, optionList)
        },
        storeReferrers: function (data, action) {
            let optionList = []
            data.map((element) => {
                element.users.map((user) => {
                    optionList.push({
                        label: `${element.name} - ${user.first_name} ${user.last_name}`,
                        value: user.id,
                        teamID: element.team_id,
                    })
                })
            })
            this.$store.dispatch(action, optionList)
        },
        storeBrokers: function (data, action) {
            let optionList = []
            data.map((element) => {
                const disabled = element.active === 0
                optionList.push({
                    label: `${element.first_name} ${element.last_name}${disabled ? " (Deactivated)" : ""}`,
                    value: element.id,
                    teams: _.map(element.teams, "id"),
                    disabled,
                })
            })
            this.$store.dispatch(action, optionList)
        },
        storeFinanceDetails: function (data) {
            this.$store.commit("summary/setAmountToFinance", data.amount)
            this.$store.commit("summary/setDeposit", data.deposit)
            this.$store.commit("summary/setBalloon", data.balloon)
            this.$store.commit("summary/setAmountToFinanced", data.amount_to_financed)
            this.$store.commit("summary/setTrade", data.trade)
            this.$store.commit("summary/setPayout", data.payout)
            this.$store.commit("summary/setRepaymentFrequency", data.preferred_repayment_frequency)
            this.$store.commit("summary/setRepaymentAmount", data.preferred_repayment_amount)
            this.$store.commit("summary/setRepaymentTerm", data.preferred_repayment_term)
            this.$store.commit("summary/setApplicationType", data.application_type_id)

            this.$store.commit("summary/setPaymentType", data.payment_type)
            this.$store.commit("summary/setLoanType", data.loan_type_id)
            this.$store.commit("summary/setSellerType", data.seller_type_id)
        },
    },
}
</script>

<style lang="scss" scoped>
.application-tab-nav {
    * {
        transition: position 0.5s, margin 0.5s, width 0.5s, opacity 0.5s, top 0.5s, left 0.5s;
    }

    &.sticky-active {
        .inner-nav {
            top: 0;
            width: 100%;
            left: 0;
            position: fixed;
            z-index: 999;

            a {
                border-radius: 0;

                span {
                    display: inline-block;
                }
            }
        }
    }

    // Tabs panel
    #tabs-panel {
        z-index: 0;
        position: relative;
    }

    &.sticky-active #tabs-panel {
        transition: background-color 0.5s;
        transition-delay: 0.5s;
        background-color: #fff;
    }

    // Info panel
    .info-panel-container {
        position: relative;
    }

    #info-panel {
        transition: none;
        box-shadow: 0px 0px 10px 1px #a7a7a7;
        background: #fff;
        padding: 10px 0;
        opacity: 0;
        z-index: -1;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -100px;
        width: 100%;

        &.hidden {
            opacity: 0.2;
        }
    }

    &.sticky-active #info-panel {
        transition: top 0.75s, opacity 1.25s;
        transition-delay: 0.25s;
        display: flex;
        opacity: 1;
        top: 0;
        width: 100%;
    }
}
</style>
